import { DeleteCrecaAccountsApi } from "@/features/accounts/creca/services/delete-accounts-api";
import { DeleteCrecaAccountsRequestModel } from "@/features/accounts/creca/services/delete-accounts-model";

/// クレカ削除画面処理
export class DeleteCrecaAccountsService {
  private deleteCrecaAccountsApi = new DeleteCrecaAccountsApi();

  /**
   * クレカ削除API実行
   */
  public async deleteCrecaAccounts(param: DeleteCrecaAccountsRequestModel) {
    return await this.deleteCrecaAccountsApi.deleteCrecaAccounts(param);
  }
}
